import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-playground-selector',
  templateUrl: './playground-selector.component.html',
  styleUrls: ['./playground-selector.component.scss']
})
export class PlaygroundSelectorComponent {
  @Input() businesses: any[] = [];
  @Output() select = new EventEmitter<any>();
  @Output() closeSelector = new EventEmitter<void>();

  filteredBusinesses: any[] = [];

  ngOnInit() {
    this.filteredBusinesses = [...this.businesses];
  }

  searchBusinesses(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input?.value.toLowerCase() || '';
    this.filteredBusinesses = this.businesses.filter((business) =>
      business.name?.toLowerCase().includes(searchTerm)
    );
  }

  selectBusiness(business: any) {
    this.select.emit(business);
  }

  close() {
    this.closeSelector.emit();
  }
} 